import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Translate from '@securitize/ui-components/i18n/Translate';

const DefaultContent = ({
  title, status, paragraph, size,
}) => (
  <>
    <h6
      className={classNames('set-card_data__title', {
        'font-16': size === 'small',
        'font-20': size === 'big',
      })}
    >
      <Translate translationKey={title} />
    </h6>
    <p
      className={classNames('', {
        'font-16': size === 'small',
        'font-20': size === 'big',
      })}
    >
      {
        status
          ? <Translate translationKey="Texts.completed" />
          : <Translate translationKey={paragraph} />
      }
    </p>
  </>
);

DefaultContent.defaultProps = {
  status: false,
  paragraph: '',
  size: 'small',
};

DefaultContent.propTypes = {
  title: PropTypes.string.isRequired,
  paragraph: PropTypes.string,
  status: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'big']),
};

export default DefaultContent;
